import movMonedaService from '../services/movMonedaService';
import { toLocalDateInputValue } from './facturaVentaFechas';

export const normalizarFechaCotizacion = (fecha: string | Date | null | undefined): string => {
  if (fecha == null || fecha === '') {
    return toLocalDateInputValue(new Date());
  }
  if (typeof fecha === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
    return fecha;
  }
  return toLocalDateInputValue(fecha) || toLocalDateInputValue(new Date());
};

/** Cotización vigente para la fecha: del día primero, si no última por moneda. */
export const resolverCotizacionParaFecha = async (
  codigoMoneda: number,
  fecha: string | Date | null | undefined,
): Promise<number | null> => {
  if (!codigoMoneda || codigoMoneda <= 0) return null;
  const fechaNorm = normalizarFechaCotizacion(fecha);

  try {
    const delDia = await movMonedaService.getCotizacionDia(codigoMoneda, fechaNorm);
    if (delDia.cotizacion > 0) return delDia.cotizacion;
  } catch {
    /* sin cotización del día */
  }

  try {
    const exacta = await movMonedaService.getMovMoneda(codigoMoneda, fechaNorm);
    if (exacta.cotizacion > 0) return exacta.cotizacion;
  } catch (error) {
    const status = (error as { response?: { status?: number } })?.response?.status;
    if (status && status !== 404) {
      console.error(`Error al obtener cotización exacta moneda ${codigoMoneda}:`, error);
    }
  }

  return movMonedaService.getUltimaCotizacionPorMoneda(codigoMoneda);
};
